import React from 'react';
import { useIsMobile, useT } from '@repo/common';
import SkillsContent from './Skills/SkillsContent';
import SkillsBanner from './Skills/SkillsBanner';
import StepTitle from '../Common/StepTitle';
import MobileSkillsContent from './Skills/MobileSkillsContent';

const SkillStep = ({ resumeData, setResumeData }) => {
  const isMobile = useIsMobile();
  const t = useT();

  return (
    <div>
      <div className='w-full flex flex-col items-start'>
        <StepTitle title={t('Skills', '스킬')} $isMobile={isMobile} />
        <div className='w-full flex flex-col tabletH:flex-row items-start gap-[30px] tabletH:gap-0'>
          <div className='flex-1 tabletH:pr-6 w-full'>
            {isMobile ? (
              <MobileSkillsContent
                skill={resumeData.skill}
                setResumeData={setResumeData}
                $isMobile={isMobile}
              />
            ) : (
              <SkillsContent
                skill={resumeData.skill}
                setResumeData={setResumeData}
              />
            )}
          </div>
          <SkillsBanner $isMobile={isMobile} />
        </div>
      </div>
    </div>
  );
};

export default SkillStep;
